module.exports = __webpack_public_path__ + "311c51e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/download/logo.png
// module id = 1277
// module chunks = 13